import { useState } from "react";
import { useApi } from "../../utils/api/useApi";
import { SubmitEmailDto } from "../../models/signupEmailDto";
import { signupEndpoint } from "../../utils/api/urls";

export const useSubmitEmail = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const { post } = useApi<void>();

  const submitEmail = async (signupDto: SubmitEmailDto) => {
    setLoading(true);
    setError(null);

    try {
      await post(
        signupEndpoint,
        { email: signupDto.email, language: signupDto.language },
        { headers: { "X-Kamstrup-WorkflowId": signupDto.workflowId } }
      );
    } catch (err: any) {
      setError(err.message || "Failed to send email.");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { submitEmail, loading, error };
};
